import type { HsBox } from '../../math-new/shapes/box.class';
import { HsRegularGeometryData } from '../geometry-utils/regular-geometry-data.class';

export function hsGenerateLineCubeGeometryData(box: HsBox): HsRegularGeometryData {
  const vertices: number[] = [];
  const a: [number, number, number] = [box.max.x, box.max.y, box.max.z];
  const b: [number, number, number] = [box.min.x, box.max.y, box.max.z];
  const c: [number, number, number] = [box.min.x, box.min.y, box.max.z];
  const d: [number, number, number] = [box.max.x, box.min.y, box.max.z];
  const e: [number, number, number] = [box.max.x, box.max.y, box.min.z];
  const f: [number, number, number] = [box.min.x, box.max.y, box.min.z];
  const g: [number, number, number] = [box.min.x, box.min.y, box.min.z];
  const h: [number, number, number] = [box.max.x, box.min.y, box.min.z];
  vertices.push(...a, ...b, ...b, ...c, ...c, ...d, ...d, ...a);
  vertices.push(...e, ...f, ...f, ...g, ...g, ...h, ...h, ...e);
  vertices.push(...a, ...e, ...b, ...f, ...c, ...g, ...d, ...h);
  return new HsRegularGeometryData(vertices, []);
}
